var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "icon-error--system",
      attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 280 178" },
    },
    [
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("path", {
          attrs: {
            fill: "#CBCBD4",
            d:
              "M189.996 4h-100a5 5 0 0 0-5 5v125a5 5 0 0 0 5 5h100a5 5 0 0 0 5-5V9a5 5 0 0 0-5-5m0 2c1.654 0 3 1.346 3 3v125c0 1.654-1.346 3-3 3h-100c-1.654 0-3-1.346-3-3V9c0-1.654 1.346-3 3-3h100",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            fill: "#CBCBD4",
            d:
              "M147.996 33.5h-16c-19.33 0-35 15.67-35 35s15.67 35 35 35h16c19.33 0 35-15.67 35-35s-15.67-35-35-35m0 2c18.196 0 33 14.804 33 33 0 18.196-14.804 33-33 33h-16c-18.196 0-33-14.804-33-33 0-18.196 14.804-33 33-33h16",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            stroke: "#CBCBD4",
            "stroke-width": "2",
            d:
              "M123.996 68.5a6 6 0 0 1-12 0 6 6 0 0 1 12 0zM167.996 68.5a6 6 0 0 1-12 0 6 6 0 0 1 12 0zM146.996 93.5v-4a7 7 0 1 0-14 0v4h14z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            fill: "#6E6E73",
            d: "M194.996 134V12h-97a5 5 0 0 0-5 5v122h97a5 5 0 0 0 5-5",
            opacity: ".15",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "icon-error--system__spark",
          attrs: {
            fill: "#FFF",
            stroke: "#CBCBD4",
            "stroke-width": "2",
            d:
              "M187.749 43.531l5.667-15.315a1 1 0 0 0-.764-1.332l-8.798-1.55a1 1 0 0 1-.55-1.677L203.583 2.43c.75-.785 2.038.02 1.66 1.038l-5.666 15.316a1 1 0 0 0 .764 1.332l8.798 1.551a1 1 0 0 1 .549 1.676L189.41 44.57c-.75.785-2.038-.019-1.661-1.038zM199.868 57.552l9.734-8.081a.775.775 0 0 0 .004-1.19l-5.301-4.448a.775.775 0 0 1 .28-1.338l21.827-6.386c.807-.236 1.359.802.712 1.339l-9.735 8.082a.774.774 0 0 0-.003 1.189l5.3 4.448a.775.775 0 0 1-.28 1.338l-21.826 6.387c-.807.235-1.36-.803-.712-1.34z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            fill: "#FFF",
            d:
              "M93.619 122.57a3.995 3.995 0 0 1-3.536-2.125 4.004 4.004 0 0 1 1.654-5.409l17.659-9.39a4 4 0 0 1 5.41 1.654 4.007 4.007 0 0 1-1.654 5.411l-17.66 9.388a3.947 3.947 0 0 1-1.873.47",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            fill: "#CBCBD4",
            d:
              "M111.269 104.178c-.792 0-1.595.188-2.343.586l-17.659 9.39a5 5 0 0 0-2.067 6.762 5 5 0 0 0 6.762 2.067l17.659-9.39a5.001 5.001 0 0 0-2.352-9.415m0 2a3.001 3.001 0 0 1 1.413 5.649l-17.659 9.39a2.999 2.999 0 0 1-4.057-1.24 2.973 2.973 0 0 1-.22-2.285 2.977 2.977 0 0 1 1.46-1.773l17.659-9.39a2.96 2.96 0 0 1 1.404-.351",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            fill: "#6E6E73",
            d:
              "M115.688 106.831a4.99 4.99 0 0 0-.713-.99 5.652 5.652 0 0 1-2.854 3.715l-20.029 10.65a5.63 5.63 0 0 1-2.916.652c.01.02.014.038.024.057a5 5 0 0 0 6.762 2.067l17.659-9.388a5 5 0 0 0 2.067-6.763",
            opacity: ".15",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            fill: "#FFF",
            d:
              "M82.909 110.876a3.997 3.997 0 0 1-3.537-2.123 4.005 4.005 0 0 1 1.655-5.41l17.658-9.389a4 4 0 0 1 5.704 4.701 3.979 3.979 0 0 1-1.947 2.363l-17.66 9.389a4.01 4.01 0 0 1-1.873.469",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            fill: "#CBCBD4",
            d:
              "M100.56 92.484c-.793 0-1.596.19-2.344.587l-17.659 9.39a5 5 0 1 0 4.694 8.83l17.66-9.39a5 5 0 0 0-2.352-9.417m0 2c1.114 0 2.13.61 2.653 1.593.376.708.454 1.52.22 2.286a2.982 2.982 0 0 1-1.46 1.771l-17.66 9.39a3 3 0 0 1-4.277-3.525 2.977 2.977 0 0 1 1.461-1.773l17.66-9.389a2.958 2.958 0 0 1 1.403-.353",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            fill: "#6E6E73",
            d:
              "M104.978 95.139a5.01 5.01 0 0 0-.713-.992 5.656 5.656 0 0 1-2.854 3.717l-20.029 10.649a5.64 5.64 0 0 1-2.916.652c.01.019.013.039.023.058a5.001 5.001 0 0 0 6.762 2.067l17.66-9.39a5 5 0 0 0 2.067-6.761",
            opacity: ".15",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            fill: "#FFF",
            d:
              "M82.662 130.825a13.054 13.054 0 0 1-9.19-4.088 13.057 13.057 0 0 1-3.608-9.389 13.088 13.088 0 0 1 3.694-8.78c.035-.037.066-.075.095-.115l8.164-8.56c.148-.168.274-.299.405-.426l.073-.076c.023-.018.046-.037.068-.057.33-.303.615-.53.9-.715 1.191-.776 2.586-1.17 4.143-1.17 4.656 0 9.921 3.466 13.413 8.83 2.37 3.64 3.635 7.67 3.565 11.351-.068 3.538-1.369 6.308-3.664 7.803a7.058 7.058 0 0 1-.945.504l-.034.016a7.698 7.698 0 0 1-1.289.435l-11.208 3.742a.85.85 0 0 0-.09.025 13.092 13.092 0 0 1-4.148.675l-.344-.005z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            fill: "#CBCBD4",
            d:
              "M87.406 96.45c-1.7 0-3.301.427-4.69 1.331a7.96 7.96 0 0 0-1.03.816l-.006-.009-.154.161a7.72 7.72 0 0 0-.432.454l-8.26 8.66.006.01a14.066 14.066 0 0 0-3.975 9.45c-.202 7.807 5.963 14.3 13.77 14.502a14.059 14.059 0 0 0 4.835-.722l.003.004 11.204-3.744a8.141 8.141 0 0 0 1.388-.465l.127-.042-.005-.008a7.93 7.93 0 0 0 1.078-.577c5.339-3.475 5.515-12.67.392-20.539-3.79-5.82-9.418-9.283-14.251-9.283m0 2c4.327 0 9.263 3.287 12.575 8.375 2.26 3.473 3.47 7.304 3.404 10.787-.062 3.195-1.202 5.676-3.211 6.984a5.896 5.896 0 0 1-.81.43l-.002.001-.09.036a6.266 6.266 0 0 1-1.05.353 1.848 1.848 0 0 0-.18.051l-11.088 3.706c-.04.01-.078.022-.116.035a12.077 12.077 0 0 1-4.15.62 12.062 12.062 0 0 1-8.49-3.778 12.065 12.065 0 0 1-3.334-8.675 12.096 12.096 0 0 1 3.413-8.112 1.92 1.92 0 0 0 .14-.16l8.124-8.519.054-.06c.104-.118.213-.23.326-.342.018-.016.035-.034.053-.052.023-.02.046-.039.067-.06.287-.264.53-.458.767-.612 1.027-.669 2.238-1.008 3.598-1.008",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            fill: "#6E6E73",
            d:
              "M101.855 106.062c1.492 6.454.066 12.433-4.233 15.232a9.13 9.13 0 0 1-1.259.673l.007.01-.149.049a9.528 9.528 0 0 1-1.619.54l-13.07 4.37-.004-.004a16.423 16.423 0 0 1-8.825.444 14.094 14.094 0 0 0 9.933 4.45 14.079 14.079 0 0 0 4.834-.722l.002.004 11.204-3.744a8.32 8.32 0 0 0 1.388-.465l.127-.042-.005-.01c.37-.165.733-.35 1.08-.575 5.263-3.428 5.496-12.416.59-20.21",
            opacity: ".15",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            fill: "#FFF",
            d:
              "M40.784 175.24a4.008 4.008 0 0 1-3.691-2.45c-.802-1.885.093-4.17 2.038-5.204l19.723-10.488a.998.998 0 0 0-.001-1.765l-19.98-10.624c-.86-.4-1.5-.999-1.904-1.758a4.006 4.006 0 0 1 1.654-5.41l35.318-18.779a3.995 3.995 0 0 1 5.41 1.655c.5.943.605 2.024.293 3.047a3.976 3.976 0 0 1-1.947 2.362l-26.988 14.35a.998.998 0 0 0 0 1.765l20.2 10.741a3.98 3.98 0 0 1 1.769 1.883c.858 1.883-.033 4.261-1.987 5.3L42.658 174.77a3.947 3.947 0 0 1-1.874.47",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            fill: "#CBCBD4",
            d:
              "M75.814 117.293c-.792 0-1.595.189-2.343.587l-35.318 18.778a5.003 5.003 0 0 0-2.068 6.763 4.966 4.966 0 0 0 2.318 2.171l19.98 10.624-19.722 10.487c-2.328 1.237-3.52 4.053-2.49 6.479a5 5 0 0 0 6.955 2.471l25.908-13.774 2.126-1.131c2.37-1.261 3.54-4.154 2.427-6.598a4.99 4.99 0 0 0-2.203-2.347l-.005-.003-20.2-10.741 26.987-14.35a5 5 0 0 0-2.352-9.416m0 2c1.114 0 2.131.61 2.653 1.593a3.003 3.003 0 0 1-1.24 4.057l-26.988 14.35a2 2 0 0 0 0 3.531l20.206 10.744c.586.312 1.043.8 1.322 1.412.644 1.411-.05 3.207-1.546 4.002l-2.126 1.13-25.907 13.776c-.44.233-.913.352-1.405.352a3.009 3.009 0 0 1-2.77-1.841c-.6-1.411.096-3.138 1.587-3.93l19.722-10.488a1.998 1.998 0 0 0 0-3.531l-19.98-10.624a2.28 2.28 0 0 0-.099-.049 2.974 2.974 0 0 1-1.39-1.296 3.001 3.001 0 0 1 1.24-4.056l35.317-18.779a2.96 2.96 0 0 1 1.404-.353",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            fill: "#6E6E73",
            d:
              "M80.498 120.593a3.67 3.67 0 0 0-.258-.631l-.006-.015-.004-.005a4.114 4.114 0 0 0-.295-.468l-.08-.11a6.312 6.312 0 0 0-.336-.41 4.958 4.958 0 0 1-2.353 2.755L51.14 135.547c-2.216 1.179-2.216 4.354 0 5.532l26.225-13.944.8-.426c2.229-1.184 3.172-3.81 2.332-6.116M73.587 154.15a5.006 5.006 0 0 0-.887-1.328 5.427 5.427 0 0 1-2.54 2.926l-2.126 1.131-31.612 16.811a5 5 0 0 0 6.705 1.963l25.907-13.774 2.126-1.13c2.37-1.262 3.54-4.156 2.427-6.599",
            opacity: ".15",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "icon-error--system__effect",
          attrs: {
            stroke: "#CBCBD4",
            "stroke-linecap": "round",
            "stroke-width": "2",
            d:
              "M72.233 88v5.933M51.467 108.766H57.4M57.55 94.082l4.194 4.195M262.417 82.621l4.242-4.242M262.417 78.379l4.242 4.242",
          },
        }),
        _vm._v(" "),
        _c("g", { staticClass: "icon-error--system__twinkle" }, [
          _c(
            "g",
            {
              attrs: {
                stroke: "#FF7450",
                "stroke-linecap": "round",
                "stroke-width": "2",
                opacity: ".3",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M228.417 128.379l4.242 4.242M232.66 128.379l-4.243 4.242",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "g",
            {
              attrs: {
                stroke: "#FF7450",
                "stroke-linecap": "round",
                "stroke-width": "2",
                opacity: ".3",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M69.417 11.621L73.66 7.38M69.417 7.379l4.242 4.242",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "g",
            {
              attrs: {
                stroke: "#CBCBD4",
                "stroke-linecap": "round",
                "stroke-width": "2",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M18.417 52.621l4.242-4.242M18.417 48.379l4.242 4.242",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "g",
            {
              attrs: {
                stroke: "#FF7450",
                "stroke-linecap": "round",
                "stroke-width": "2",
                opacity: ".3",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M36.835 91.736l4.242-4.242M36.835 87.494l4.242 4.242",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "g",
            {
              attrs: {
                stroke: "#CBCBD4",
                "stroke-linecap": "round",
                "stroke-width": "2",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M243.417 11.379l4.242 4.242M247.66 11.379l-4.243 4.242",
                },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("path", {
          attrs: {
            fill: "#E4FF18",
            d:
              "M140 167c-32.585 0-59-3.134-59-7s26.415-7 59-7 59 3.134 59 7-26.415 7-59 7z",
            opacity: ".3",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }